import { render, staticRenderFns } from "./PrioridadesPlanejadas.vue?vue&type=template&id=59d2ee48&scoped=true&"
import script from "./PrioridadesPlanejadas.vue?vue&type=script&lang=js&"
export * from "./PrioridadesPlanejadas.vue?vue&type=script&lang=js&"
import style0 from "./PrioridadesPlanejadas.vue?vue&type=style&index=0&id=59d2ee48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d2ee48",
  null
  
)

export default component.exports